import { API_BASE_URL, apiClient, getAccessToken } from './apiClient';

const API_BASE = API_BASE_URL;

let eventSource = null;
let reconnectTimer = null;
let lastConnectOptions = { enabled: true, token: null };

export function connectRealtime({ enabled = true, token } = {}) {
  const activeToken = token || getAccessToken();
  lastConnectOptions = { enabled, token: activeToken };
  if (!enabled || eventSource) return eventSource;
  
  const url = `${API_BASE.replace(/\/$/, '')}/realtime/events${activeToken ? `?accessToken=${encodeURIComponent(activeToken)}` : ''}`;
  eventSource = new EventSource(url, { withCredentials: true });

  eventSource.onmessage = (event) => {
    window.dispatchEvent(new CustomEvent('servicedesk:realtime', { detail: JSON.parse(event.data || '{}') }));
  };

  [
    'notification.created',
    'ticket.created',
    'ticket.assigned',
    'ticket.message.created',
    'ticket.status.changed',
    'invoice.created',
    'invoice.paid',
    'service.requested',
    'service.approved',
    'automation.executed',
    'escalation.created',
    'audit.created'
  ].forEach((type) => {
    eventSource.addEventListener(type, (event) => {
      window.dispatchEvent(new CustomEvent(`servicedesk:${type}`, { detail: JSON.parse(event.data || '{}') }));
    });
  });

  eventSource.onerror = async () => {
    disconnectRealtime();
    
    try {
      // Fetch /auth/me to let axios interceptor refresh token if expired
      await apiClient.get('/auth/me');
      const freshToken = getAccessToken();
      if (freshToken) {
        reconnectTimer = window.setTimeout(() => {
          connectRealtime({ enabled: lastConnectOptions.enabled, token: freshToken });
        }, 5000);
      }
    } catch (err) {
      console.warn('Realtime reconnect stopped because session is invalid or expired:', err);
    }
  };

  return eventSource;
}

export function disconnectRealtime() {
  if (reconnectTimer) window.clearTimeout(reconnectTimer);
  reconnectTimer = null;
  if (eventSource) eventSource.close();
  eventSource = null;
}
